// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-row-column-multi',
    // #endregion
    // #region Properties
    props: {
        content: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
    // #region Methods
    methods: {}
    // #endregion
});
// #endregion
